<template>
  <div
    class="course-details-container"
    :class="{[`theme-${theme}`] : theme}"
  >
    <ContainerMedium>
      <slot />
    </ContainerMedium>
  </div>
</template>

<script>
  import ContainerMedium from '@/components/layout/containers/ContainerMedium'

  export default {
    components: {
      ContainerMedium,
    },

    props: {
      theme: { type: String, default: '' }
    },
   
  }
</script>

<style scoped lang="scss">
  @import '~@/assets/sass/variables';

  .course-details-container {
    position: relative;
    background-color: lighten(#0F0F0F, 10%);
    padding: 1.875rem 0;

    &.theme-light {
      background-color: #fff;
    }

    @media (max-width: 550px) {
      padding: 0;
    }
  }
</style>